import request from "@/utils/request"; //记得引入进来

export function getReaderHistory(params) {
    return request({
        method: 'get',
        url: '/reader/view-history',
        params: params
    })
}

export function getReaderDownload(params) {
    return request({
        method: 'get',
        url: '/reader/view-download',
        params: params
    })
}

export function getReaderShelf(params) {
    return request({
        method: 'get',
        url: '/reader/view-shelf',
        params: params
    })
}